import React, { useEffect } from "react";
import InitialPage from "./initialPage/initialPage";
import EmailSignIn from "./emailSignIn/emailSignIn";
import EmailSignUp from "./emailSignUp/emailSignUp";
import {useLocation} from "react-router";


const RightSide = () => {
    const location = useLocation();
    const redirectTo = new URLSearchParams(location.search).get("redirectTo")

    useEffect(() => {
      if(redirectTo) {
          sessionStorage.setItem("redirectTo", redirectTo)
      }
    }, [redirectTo])

    return (
        <div style={{display:"flex", alignItems:"center", justifyContent:"center", height:location.pathname === "/signin/email-signIn" ?  "78vh" : "90vh"}} >
            {location.pathname === "/signin" && <InitialPage />}
            {location.pathname === '/signin/email-signIn' && <EmailSignIn />}
            {location.pathname === '/signup' && <EmailSignUp  />}
        </div>
    )
}

export default RightSide;
